module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.aditionalClass
  }, [_c('div', {
    staticClass: "md-form",
    attrs: {
      "id": _vm.data.id
    }
  }, [_c('input', {
    staticClass: "form-control datepicker",
    attrs: {
      "placeholder": "Select date",
      "disabled": _vm.disabled !== false,
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "date-picker"
    }
  }, [_vm._v(_vm._s(_vm.t(_vm.data.label)))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bd361866", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd361866"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/DatePicker.vue
// module id = 803
// module chunks = 3